var map = {
	"./CannaProvisions": 79196,
	"./CannaProvisions.tsx": 79196,
	"./CookiesLosAngeles": 6074,
	"./CookiesLosAngeles.tsx": 6074,
	"./Default": 57396,
	"./Default.tsx": 57396,
	"./GetDandylion": 35614,
	"./GetDandylion.tsx": 35614,
	"./HitsBlunt": 77673,
	"./HitsBlunt.tsx": 77673,
	"./Hyperwolf": 9212,
	"./Hyperwolf.tsx": 9212,
	"./Kindrun": 89599,
	"./Kindrun.tsx": 89599,
	"./Mjcom": 37914,
	"./Mjcom.tsx": 37914,
	"./Nealternatives": 71583,
	"./Nealternatives.tsx": 71583,
	"./RoyalRain": 37573,
	"./RoyalRain.tsx": 37573,
	"./Standard": 49979,
	"./Standard.tsx": 49979,
	"./TheSource": 81184,
	"./TheSource.tsx": 81184,
	"./Weedcom": 54620,
	"./Weedcom.tsx": 54620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82156;